import { Mg2Action } from "./Mg2Action";
import { Auth0ClientInstance } from "../plugins/auth/Auth0ClientInstance";
export class RegisterAction extends Mg2Action {
    constructor() {
        super(...arguments);
        this.actionName = "register";
    }
    run() {
        Auth0ClientInstance.register();
    }
}
